/**
 * Copyright 2025 Design Barn Inc.
 */

import React from 'react';

export default function FacebookIcon(): React.ReactElement {
  return (
    <div className="flex items-center justify-center rounded-[8px]">
      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.5 12.5398C22.5 6.99818 18.0229 2.50586 12.5 2.50586C6.97715 2.50586 2.5 6.99818 2.5 12.5398C2.5 17.5479 6.15684 21.699 10.9375 22.4518V15.4402H8.39844V12.5398H10.9375V10.3292C10.9375 7.81442 12.4305 6.42535 14.7146 6.42535C15.8084 6.42535 16.9531 6.62133 16.9531 6.62133V9.0906H15.6922C14.45 9.0906 14.0625 9.86412 14.0625 10.6584V12.5398H16.8359L16.3926 15.4402H14.0625V22.4518C18.8432 21.699 22.5 17.5479 22.5 12.5398Z"
          fill="#176DF0"
        />
        <path
          d="M16.3926 15.4406L16.8359 12.5402H14.0625V10.6588C14.0625 9.86533 14.45 9.09104 15.6922 9.09104H16.9531V6.62176C16.9531 6.62176 15.8088 6.42578 14.7146 6.42578C12.4305 6.42578 10.9375 7.81485 10.9375 10.3296V12.5402H8.39844V15.4406H10.9375V22.4522C11.9729 22.6147 13.0271 22.6147 14.0625 22.4522V15.4406H16.3926Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
